// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import VeeValidate, { Validator } from "vee-validate";
import es from "@/core/locale/translation/validation/es_MX";
import Vuex from "vuex";
import { config } from "@/core/config/base";
import { filters } from "@/core/libs/filters";

Vue.use(Vuex);
Vue.use(VeeValidate, {
  events: ""
});
Validator.localize("es", es);

Vue.config.productionTip = false;

Vue.filter("date", filters.date);
Vue.filter("hour", filters.hour);
Vue.filter("boolean", filters.boolean);
Vue.filter("multiple", filters.multipleOptions);
Vue.filter("multipleNumeric", filters.multipleNumeric);
Vue.filter("singleSelection", filters.singleSelection);
Vue.filter("noQuotes", filters.noQuotes);
Vue.filter("price", filters.price);
Vue.filter("longDate", filters.longDate);

const store = new Vuex.Store({
  state: {
    isLoggedIn: false,
    notification: null,
    loading: false,
    toggleSidebar: true,
    lang: config.lang.default,
    user: null,
    elementChanged: null
  },
  mutations: {
    login: state => {
      state.isLoggedIn = true;
    },
    logout: state => {
      state.isLoggedIn = false;
    },
    notificate(state, data) {
      state.notification = data;
    },
    hideSidebar: state => {
      state.toggleSidebar = false;
    },
    showSidebar: state => {
      state.toggleSidebar = true;
    },
    wait: state => {
      state.loading = true;
    },
    ready: state => {
      state.loading = false;
    },
    user(state, data) {
      state.user = data;
    },
    elementChanged(state, data) {
      state.elementChanged = data;
    }
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>"
});


// WEBPACK FOOTER //
// ./src/main.js